<template>
  <div class="div_item" @click.capture.stop="playLecture(lectureData.course_no)">
    <div class="div_relative">
      <div class="point-wrapper" v-if="lectureData.bonus > 0">
        <label class="lbl_default2 lbl_bold">{{lectureData.bonus}}P</label>
      </div>
      <img class="img-content" v-if="lectureData.thumb_url !== null && lectureData.thumb_url !== ''" v-bind:src="lectureData.thumb_url" />
      <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/content/data/201908/da2302a0d96147c5b40d43e5e94782cf.png" />
      <div v-if="status == $c.MISSION_STATUS.FINISHED" class="mask" />
      <div v-if="status == $c.MISSION_STATUS.FINISHED" class="mask_content div_relative">
        <img src="/assets/new/ic_pop_bg1.png" style="width: 90px; height: 90px;">
        <div class="mission_finish_bonus_pop v-layout center justify-center">
          <label class="lbl_default3 lbl_bold" style="letter-spacing: -1px">{{$t('lecture.state_finish')}}</label>
          <label class="lbl_default7 lbl_bold color_brown">{{lectureData.bonus}}P</label>
        </div>
      </div>
    </div>
    <div class="ml-1 mr-1 mb-1">
      <div class="h-layout align-items-center mb-1" style="justify-content: space-between">
        <div class="h-layout">
          <subject-badge v-if="lectureData.lecture_div === '20'" :label="lectureData.plan_subject_name" :border-color="'green1'" :border-width="2" />
          <subject-badge v-else :label="lectureData.subject_name" :border-color="'green1'" :border-width="2" />

          <subject-badge v-if="lectureData.school_div === '10'" :label="lectureData.school_div_name | convertSchoolGrade" :border-color="'yellow'" :border-width="2" />
          <subject-badge v-if="lectureData.school_div === '20'" :label="lectureData.school_div_name | convertSchoolGrade" :border-color="'green'" :border-width="2" />
          <subject-badge v-if="lectureData.school_div === '99'" :label="lectureData.school_div_name | convertSchoolGrade" :border-color="'blue'" :border-width="2" />
        </div>
        <button @click="e => playLectureMini(e, lectureData.course_no)" style="background-color: transparent">
          <img src="/assets/new/ic_play.png" class="img_play">
        </button>
      </div>
      <div class="lbl_title word_comma_1">{{lectureData.course_name}}</div>
      <div>
        <div class="lbl_tag word_comma_2">{{ lectureData.keyword }}</div>
      </div>
      <div v-if="lectureData.teacher_name" style="margin-top: 5px">
        <label class="lbl_writer">{{ lectureData.teacher_name }} · {{ lectureData.teacher_div_name}} </label>
      </div>
      <div class="display-flex align-items-center" style="margin-top: 9px" v-if="showDetail">
        <img class="img_heart" src="/assets/new/ic_heart_grey.png">
        <label class="lbl_heart">{{ lectureData.like_count }}</label>
        <div class="ml-3" />
        <img class="img_reply" src="/assets/new/ic_reply1.png">
        <label class="lbl_heart">{{ lectureData.comment_count }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import SubjectBadge from "../../components/SubjectBadge";
import * as utils from "../../utils/utils";
import * as biz from "../../utils/biz";
export default {
  name: "LectureCardItem",
  components: {SubjectBadge},
  props: {
    showDetail:{
      type:Boolean,
      default: false,
    },
    bonus: {
      type: Number,
      default: 50,
    },
    status: {
      type: String,
      default: ''
    },
    lectureData: {
      type: Object,
      default: () => {
        return {
          subject: 'Sum'
        }
      },
    }
  },
  data() {
    return {

    }
  },
  methods: {
    playLecture(course_no) {
      this.$emit("playLecture");
      this.$store.state.showMissionPopup = false;
      biz.playAudioPlayer(course_no);
    },
    playLectureMini(e,course_no) {
      this.$emit("playLecture");
      e.stopPropagation();
      biz.playAudioPlayer(course_no, 'mini');
    },

  },
  filters:{
    convertSchoolGrade(value) {
      return utils.convertSchoolGrade(value);
    },
  }
}
</script>

<style scoped lang="scss">
.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  z-index: 1;
  left: 0;
  top: 0;
  border-radius: 20px;
  background-color: $primary-color;
}
.mask_content {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.mission_finish_bonus_pop {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.point-wrapper {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 20px;
  left: 20px;
  width: 40px;
  height: 40px;
  background-color: $primary-color;
  color: white;
  border-radius: 50%;
  border: solid 2px white;
}
.div_item {
  width: 150px;
  flex: 0 0 auto;
  margin-right: 12px;

  img {
    width: 100%;
    border-radius: 20px;
  }

  .lbl_title {
    font-size: $font-base16;
    font-weight: $font-weight700;
  }

  .lbl_tag {
    font-size: $font-base13;
    font-weight: $font-weight700;
    color: $primary-color;
  }

  .lbl_writer {
    font-size: $font-base13;
    font-weight: $font-weight500;
    color: #868e95;
  }

  .img_heart {
    width: 15px;
    height: 15px;
    border-radius: 0;

  }

  .lbl_heart {
    font-size: $font-base11;
    color: #868e95;
    margin-left: 3px;
  }

  .img_reply {
    width: 15px;
    height: 15px;
    margin-left: 10px;
    border-radius: 0;

  }
  .img-content{
    height: 125px;
  }
}
.img_play {
  width: 24px !important;
  height: 24px !important;
}
</style>